import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { AuthService } from '../_services/auth.service';

/** Login's existing approval decision, shared with payment entry routes. */
export const requiresApproval = (user: any): boolean =>
  !user.isApproved && ['Pending', 'Reject'].includes(user.state);

/** Resolve the server profile before mounting any payment UI. */
export const paymentEntryGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  // Local-storage authentication cannot be determined during SSR.
  if (!auth.isBrowser()) return false;
  const pricing = route.routeConfig?.path === 'pricing';
  const destination = router.parseUrl(state.url);
  destination.root.children['primary'].segments[0].path = 'payment';
  if (!auth.isLoggedIn()) {
    if (pricing) return true;
    destination.root.children['primary'].segments[0].path = 'pricing';
    return destination;
  }
  return auth.getUserProfile().pipe(
    take(1),
    map((response: any) => {
      const user = response?.data ?? response;
      if (!user || response?.status === false) return false;
      if (requiresApproval(user) || !user.isGetPremimum) {
        auth.setRedirectUrl(pricing ? router.serializeUrl(destination) : state.url);
        localStorage.setItem('Pending_User_Data', JSON.stringify(user));
        return router.createUrlTree(['/approval']);
      }
      auth.updateUserProfile(user);
      return pricing ? destination : true;
    }),
    // Authentication / approval errors retain the existing interceptor flow.
    catchError(() => of(false)),
  );
};
